{
  "TITLE": "Name",
  "MESSAGE": "Message",
  "CONSENT_PREFERENCES": {
    "TITLE": "Consent Preference",
    "DESCRIPTION_INTRO": "Manage how {{ senderName }} can message you.",
    "MARKETING_TOGGLE_LABEL": "All SMS messages",
    "MARKETING_TOGGLE_DESCRIPTION": "Reminders, alerts, and other messages sent by text to your mobile number.",
    "SAVE_SUCCESS": "Your messaging preferences have been updated.",
    "INVALID_LINK": "This link is invalid or has expired.",
    "GENERIC_ERROR": "Something went wrong. Please try again."
  },
  "SMS_REGISTRATION": {
    "ALERT": {
      "BUSINESS_INFO_REQUIRED_TITLE": "Business information required",
      "MORE_DETAILS_SUGGESTION": "More details are needed about your business to send SMS messages to customers.",
      "UPDATE_INFO_ACTION_TITLE": "Update business info",
      "REJECTED_TITLE": "SMS registration rejected",
      "REJECTED_SUGGESTION": "update your information and try submitting again to access SMS features."
    },
    "FORM": {
      "CAMPAIGN_INFO": {
        "TITLE": "Campaign policy information",
        "PRIVACY_POLICY_LABEL": "Privacy Policy URL",
        "PRIVACY_POLICY_HINT": "Link directly to your privacy policy page. Must be publicly accessible.",
        "TERMS_AND_CONDITIONS_LABEL": "Terms of Service URL",
        "TERMS_AND_CONDITIONS_HINT": "Link directly to your terms of service page. Must be publicly accessible.",
        "URL_FORMAT_ERROR": "Please enter a valid URL starting with http:// or https://",
        "TERMS_ALERT_BODY": "Your terms of service must cover the following topics related to your SMS messaging program:",
        "DESCRIPTION_LABEL": "Campaign description",
        "DESCRIPTION_HINT": "Describe what messages you send to customers (40–4096 characters)",
        "MESSAGE_FLOW_LABEL": "Message flow",
        "MESSAGE_FLOW_HINT": "Describe how you obtain consent from customers to send them messages (40–2048 characters)",
        "MIN_LENGTH_ERROR": "Must be at least 40 characters"
      },
      "BUSINESS_INFO": {
        "TITLE": "Business information",
        "LEGAL_NAME_LABEL": "Legal business name",
        "LEGAL_NAME_HINT": "This must be the same name your business uses for tax purposes. For example: Roadside Coffee Inc.",
        "LEGAL_NAME_MAX_LENGTH_ERROR": "Business name should be maximum of 128 characters.",
        "CATEGORY_LABEL": "Business category",
        "TYPE_LABEL": "Business type",
        "REGION_LABEL": "Country/region",
        "REGISTRATION_NUMBER_LABEL": "Business registration number",
        "REGISTRATION_NUMBER_HINT": "For US-based companies, this must be your business EIN number",
        "ADDRESS_LABEL": "Address",
        "ADDITIONAL_ADDRESS_LABEL": "Additional address line",
        "STATE_LABEL": "State",
        "CITY_LABEL": "City",
        "ZIP_CODE_LABEL": "Zip Code",
        "ZIP_CODE_ERROR": "Not a valid zip code",
        "WEBSITE_LABEL": "Website",
        "WEBSITE_HINT": "If you don't have a business website, provide an online listing"
      },
      "AUTHORIZED_REP": {
        "TITLE": "Authorized business representative",
        "FIRST_NAME_LABEL": "First name",
        "LAST_NAME_LABEL": "Last name",
        "JOB_POSITION_LABEL": "Job position",
        "TITLE_LABEL": "Title",
        "TITLE_HINT": "For example CEO, CTO, Manager",
        "EMAIL_LABEL": "Email",
        "EMAIL_HINT": "Email of Authorized Business Representative",
        "EMAIL_ERROR": "Not a valid email",
        "PHONE_LABEL": "Phone number",
        "PHONE_HINT": "Best way to contact the authorized business representative. Required format +1-123-456-7890",
        "PHONE_ERROR": "Required format +1-123-456-7890"
      },
      "SNACKBAR": {
        "INVALID_SUBMISSION": "Invalid data for submission",
        "INVALID_FORMAT": "Invalid format for some fields",
        "SAVE_SUCCESS": "Registration Saved Successfully",
        "SAVE_ERROR": "Error Saving Registration",
        "FETCH_ERROR": "Error Fetching Registration"
      },
      "ACTIONS": {
        "SAVE_CHANGES": "Save changes",
        "SUBMIT_INFORMATION": "Submit information",
        "RESUBMIT_REGISTRATION": "Resubmit registration",
        "BACK": "Back",
        "NEXT": "Next",
        "SAVE": "Save as draft",
        "SUBMIT_REGISTRATION": "Submit Registration"
      },
      "TRIAL_RESTRICTION_MESSAGE": "Upgrade your plan to submit"
    },
    "V2": {
      "STEPS": {
        "BRAND_INFO": "Brand Info",
        "CAMPAIGN": "Campaign",
        "REVIEW": "Review"
      },
      "BRAND": {
        "TITLE": "Business Information",
        "LEGAL_NAME_LABEL": "Legal Business Name",
        "LEGAL_NAME_HINT": "Must match your EIN registration",
        "CATEGORY_LABEL": "Business Category",
        "TYPE_LABEL": "Business Type",
        "REGION_LABEL": "Region of Operation",
        "EIN_LABEL": "EIN (Employer Identification Number)",
        "EIN_HINT": "Format: XX-XXXXXXX",
        "ADDRESS_LABEL": "Street Address",
        "ADDRESS_LINE_2_LABEL": "Address Line 2",
        "STATE_LABEL": "State",
        "CITY_LABEL": "City",
        "ZIP_CODE_LABEL": "Zip Code",
        "ZIP_CODE_HINT": "Format: XXXXX or XXXXX-XXXX",
        "WEBSITE_LABEL": "Website",
        "AUTHORIZED_REP_TITLE": "Authorized Representative",
        "FIRST_NAME_LABEL": "First Name",
        "LAST_NAME_LABEL": "Last Name",
        "JOB_POSITION_LABEL": "Job Position",
        "BUSINESS_TITLE_LABEL": "Business Title",
        "EMAIL_LABEL": "Email",
        "PHONE_LABEL": "Phone Number",
        "PHONE_HINT": "Format: +1-XXX-XXX-XXXX"
      },
      "CAMPAIGN": {
        "TITLE": "Campaign Details",
        "EXAMPLE_SITE_INTRO": "For a demonstration of an A2P compliant site, see",
        "EXAMPLE_SITE_LINK": "this online tool",
        "SMS_USAGE_TITLE": "How will you use SMS?",
        "SMS_USAGE_MARKETING": "Marketing",
        "SMS_USAGE_MARKETING_DESC": "Promotional messages such as sales, discounts, coupons, and other offers intended to drive customer engagement or purchases.",
        "SMS_USAGE_TRANSACTIONAL": "Transactional",
        "SMS_USAGE_TRANSACTIONAL_DESC": "Non-promotional messages such as order confirmations, appointment reminders, delivery updates, and account notifications.",
        "SMS_USAGE_BOTH": "Both",
        "SMS_USAGE_BOTH_DESC": "A mix of promotional and informational messages, such as appointment reminders alongside special offers.",
        "VERBAL_CONSENT_TITLE": "Verbal Consent",
        "VERBAL_CONSENT_QUESTION": "Do you collect consent verbally?",
        "VERBAL_CONSENT_SCRIPT_LABEL": "Verbal consent script",
        "VERBAL_CONSENT_SCRIPT_HINT": "Enter the exact wording used when asking customers for permission to receive text messages. Use [Business Name] as a placeholder for your legal business name. It will be replaced on submission.",
        "VERBAL_CONSENT_WARNING_MESSAGE": "Having only verbal consent when using SMS for marketing often results in a higher chance of having your A2P application rejected.",
        "VERBAL_CONSENT_DEFAULT_SCRIPT": "[Business Name]: \"As part of our service, we can send you text messages to communicate regarding appointments and other customer care related topics. Message and data rates may apply. You can unsubscribe at any time by replying STOP to these messages. Would you like us to text you?\". * Customer: \"Yes please\". [Business Name]: \"Great! We will send you a text message shortly following your service where you can confirm your choice.\"",
        "VERBAL_CONSENT_DEFAULT_SCRIPT_TRANSACTIONAL": "* [Business Name]: \"As part of our service, we can send you text messages about appointments, service updates, and customer support. Message and data rates may apply. Message frequency varies. You can reply STOP to unsubscribe at any time. Would you like to receive these messages?\". * Customer: \"Yes\". * [Business Name]: \"Thank you! You're now opted in to transactional messages from us.\".",
        "VERBAL_CONSENT_DEFAULT_SCRIPT_MARKETING": "* [Business Name]: \"We'd like to send you text messages about sales, promotions, and special offers. Message and data rates may apply. Message frequency varies. You can reply STOP to unsubscribe at any time. Would you like to receive these messages?\". * Customer: \"Yes\". * [Business Name]: \"Thank you! You're now opted in to marketing messages from us.\".",
        "VERBAL_CONSENT_DEFAULT_SCRIPT_BOTH": "* [Business Name]: \"As part of our service, we can send you text messages about appointments, service updates, and customer support. Message and data rates may apply. Message frequency varies. Reply STOP to unsubscribe at any time. Would you like to receive these transactional messages?\". * Customer: \"Yes\". * [Business Name]: \"Separately, we'd also like to send you marketing texts about sales, promotions, and special offers. Would you like to receive those as well?\". * Customer: \"Yes\". * [Business Name]: \"Thank you! You're now opted in.\".",
        "WEBCHAT_TITLE": "Webchat Widget",
        "WEBCHAT_QUESTION": "Do you have a webchat embedded on your website?",
        "WEBCHAT_URL_LABEL": "Webchat widget URL",
        "WEBCHAT_URL_HINT": "Enter the URL of the page where your webchat widget appears.",
        "WEB_FORM_TITLE": "Customer Information Form",
        "WEB_FORM_QUESTION": "Do you collect customer contact information through a form on your website?",
        "WEB_FORM_URL_LABEL": "Form URL",
        "WEB_FORM_URL_HINT": "Enter the URL of the page where this form appears on your website.",
        "WEB_FORM_HELP_INTRO": "Your form must include separate consent checkboxes for each type of messaging:",
        "WEB_FORM_HELP_TRANSACTIONAL": "Transactional consent: ",
        "WEB_FORM_HELP_TRANSACTIONAL_TEXT": "A checkbox for service-related messages (e.g., appointment reminders, support updates).",
        "WEB_FORM_HELP_MARKETING": "Marketing consent: ",
        "WEB_FORM_HELP_MARKETING_TEXT": "A separate, optional checkbox for promotional messages (e.g., sales, discounts, special offers).",
        "WEB_FORM_HELP_DISCLOSURE": "Disclosure: ",
        "WEB_FORM_HELP_DISCLOSURE_TEXT": "Both checkboxes should state that message and data rates may apply, message frequency varies, the customer can reply STOP to unsubscribe or HELP for help, and include links to the Privacy Policy and Terms of Service. Consent must be optional and not required to complete the form.",
        "PRIVACY_POLICY_LABEL": "Privacy Policy URL",
        "PRIVACY_POLICY_FIELD_LABEL": "Please provide your privacy policy URL",
        "PRIVACY_POLICY_HINT": "Link directly to your privacy policy page — not a homepage or general legal page. Must be publicly accessible.",
        "PRIVACY_POLICY_HELP_TITLE": "Privacy Policy Requirements",
        "PRIVACY_POLICY_HELP_INTRO": "Your privacy policy must clearly describe how your business handles customer data for SMS messaging. Include the following:",
        "PRIVACY_POLICY_HELP_NO_SHARING": "No sharing of phone data: ",
        "PRIVACY_POLICY_HELP_NO_SHARING_TEXT": "Phone numbers and messaging data are not sold to third parties.",
        "PRIVACY_POLICY_HELP_OPT_IN": "Data collection disclosure: ",
        "PRIVACY_POLICY_HELP_OPT_IN_TEXT": "Your business collects phone numbers for the purpose of sending transactional messages (e.g., appointment reminders, order updates) and promotional messages (e.g., sales, discounts, special offers).",
        "PRIVACY_POLICY_HELP_OPT_OUT": "Data protection: ",
        "PRIVACY_POLICY_HELP_OPT_OUT_TEXT": "How customer data is stored and protected, and how customers can request their data be deleted.",
        "PRIVACY_POLICY_HELP_HELP": "Do not include: ",
        "PRIVACY_POLICY_HELP_HELP_TEXT": "References to SMS messaging from a different business, blanket permission to share phone numbers with unrelated third parties, or outdated placeholder text.",
        "PRIVACY_POLICY_HELP_RATES": "Rates: ",
        "PRIVACY_POLICY_HELP_RATES_TEXT": "Message and data rates may apply. Message frequency varies.",
        "PRIVACY_POLICY_HELP_CONSENT_SHARING": "Required consent-sharing language: ",
        "PRIVACY_POLICY_HELP_CONSENT_SHARING_TEXT": "We recommend including a statement such as: \"Text messaging originator opt-in data and consent will not be shared with any third parties, excluding aggregators and providers of the Text Message services.\" Including this language helps ensure your privacy policy meets compliance requirements.",
        "POLICIES_TITLE": "Privacy Policy & Terms of Service",
        "HTTPS_URL_ERROR": "URL must use HTTPS (e.g. https://example.com/privacy-policy)",
        "TERMS_LABEL": "Terms of Service URL",
        "TERMS_FIELD_LABEL": "Please provide your terms of service URL",
        "TERMS_HINT": "Link directly to your terms of service page — not a homepage or general legal page. Must be publicly accessible.",
        "TERMS_HELP_TITLE": "Terms of Service Requirements",
        "TERMS_HELP_INTRO": "Your terms of service must cover your SMS messaging practices. Include the following:",
        "TERMS_HELP_PROGRAM": "Program description: ",
        "TERMS_HELP_PROGRAM_TEXT": "A description of your SMS messaging program, including that customers will receive both transactional messages (e.g., appointment reminders, order updates) and promotional messages (e.g., sales, discounts, special offers).",
        "TERMS_HELP_DISCLOSURES": "Required disclosures: ",
        "TERMS_HELP_DISCLOSURES_TEXT": "\"Message and data rates may apply,\" \"Message frequency varies,\" and \"Carriers are not liable for delayed or undelivered messages.\"",
        "TERMS_HELP_OPT_OUT": "Opt-out and help: ",
        "TERMS_HELP_OPT_OUT_TEXT": "Instructions for opting out (e.g., \"Reply STOP to unsubscribe\") and getting help (e.g., \"Reply HELP for assistance\").",
        "TERMS_HELP_CONTACT": "Contact information: ",
        "TERMS_HELP_CONTACT_TEXT": "Your business contact information.",
        "TERMS_HELP_CONSENT_SHARING": "Required consent-sharing language: ",
        "TERMS_HELP_CONSENT_SHARING_TEXT": "We recommend including a statement such as: \"Text messaging originator opt-in data and consent will not be shared with any third parties, excluding aggregators and providers of the Text Message services.\" Including this language helps ensure your terms meet compliance requirements."
      },
      "REVIEW": {
        "TITLE": "Review & Submit",
        "TITLE_SUBMITTED": "Submitted Information",
        "BRAND_CARD_TITLE": "Brand Information",
        "CAMPAIGN_CARD_TITLE": "Campaign Information",
        "BUSINESS_NAME": "Business Name",
        "BUSINESS_CATEGORY": "Business Category",
        "BUSINESS_TYPE": "Business Type",
        "REGION": "Region of Operation",
        "EIN": "EIN",
        "ADDRESS": "Address",
        "CITY_STATE_ZIP": "City / State / Zip",
        "WEBSITE": "Website",
        "AUTHORIZED_REP": "Authorized Representative",
        "TITLE_POSITION": "Title / Position",
        "EMAIL": "Email",
        "PHONE": "Phone",
        "SMS_USAGE": "SMS Usage",
        "VERBAL_CONSENT": "Verbal Consent",
        "CONSENT_SCRIPT": "Consent Script",
        "WEBCHAT_WIDGET": "Webchat Widget",
        "WEBCHAT_URL": "Webchat URL",
        "WEB_FORM": "Web Form",
        "WEB_FORM_URL": "Web Form URL",
        "PRIVACY_POLICY": "Privacy Policy",
        "TERMS_OF_SERVICE": "Terms of Service",
        "SUBMITTED_DATE": "Submitted",
        "YES": "Yes",
        "NO": "No"
      },
      "ANALYSIS": {
        "TITLE": "Check your registration with AI",
        "BETA": "BETA",
        "INTRO": "Catch common A2P compliance issues before you submit. These results are AI-generated and may include mistakes.",
        "ANALYSE": "Check with AI",
        "RECHECK": "Re-check",
        "LOADING": {
          "TITLE": "Reviewing your registration",
          "STEP_1": "Reading your business & campaign details",
          "STEP_2": "Checking consent language",
          "STEP_3": "Reviewing your opt-in flow",
          "STEP_4": "Checking required disclosures"
        },
        "SUMMARY_TITLE": "Analysis summary",
        "EXAMPLE": "Example wording",
        "COPY": "Copy example wording",
        "COPIED": "Example wording copied to clipboard",
        "ERROR": "We couldn't complete the analysis. Please try again.",
        "SEVERITY": {
          "MUST_FIX": "Must fix",
          "RECOMMENDED": "Recommended",
          "OTHER": "Other"
        },
        "NO_ISSUES": "No issues found in this review — this improves your approval odds but doesn't guarantee carrier or TCR approval."
      },
      "HELP": {
        "BRAND_TITLE": "Brand Information",
        "BRAND_BODY": "Provide your legal business details and authorized representative information. This is used to register your brand with carriers for A2P messaging. Make sure your business name matches your EIN registration exactly.",
        "CAMPAIGN_TITLE": "Campaign Details",
        "CAMPAIGN_BODY": "Tell us how your business uses SMS, how you collect consent, and provide links to your privacy policy and terms of service. This information is required for campaign registration with carriers.",
        "REVIEW_TITLE": "Review & Submit",
        "REVIEW_BODY": "Review all your information before submitting. Once submitted, your registration will be reviewed by carriers. You'll be notified of the outcome."
      },
      "STATUS": {
        "REVIEWING": "Your A2P registration is currently being reviewed. You'll be notified once the review is complete.",
        "APPROVED": "Your A2P registration has been approved.",
        "BRAND_APPROVED": "Your business information has been approved.",
        "BRAND_REJECTED": "Your business information was rejected, please update and resubmit.",
        "CAMPAIGN_REJECTED": "Your campaign information was rejected, please update and resubmit.",
        "CAMPAIGN_REJECTED_WITH_REASONS": "Your campaign registration was rejected for the following reasons:",
        "CAMPAIGN_ERROR_FIELD": {
          "description": "Campaign description",
          "message_flow": "How customers opt in",
          "message_samples": "Sample messages",
          "us_app_to_person_usecase": "Campaign use case",
          "has_embedded_links": "Links in messages",
          "has_embedded_phone": "Phone numbers in messages",
          "opt_in_message": "Opt-in message",
          "opt_in_keywords": "Opt-in keywords",
          "opt_out_message": "Opt-out message",
          "opt_out_keywords": "Opt-out keywords",
          "help_message": "Help message",
          "help_keywords": "Help keywords",
          "business_registration_identifier": "Tax ID type",
          "business_registration_number": "Tax ID number",
          "social_media_profile_urls": "Social media profiles",
          "website_url": "Website",
          "brand_name": "Business name"
        },
        "CAMPAIGN_ERROR": {
          "30881": "Your brand support email is invalid or uses a public domain (like gmail.com). Use a valid email on your business domain.",
          "30882": "Your terms of service don't meet the messaging requirements. Make sure your terms page is publicly accessible, on your own domain, and includes the required SMS disclosures, then resubmit.",
          "30883": "Your campaign was rejected for restricted content (adult, hate, alcohol, firearms, tobacco/vape, or cannabis/CBD). This can't be fixed by resubmitting. To appeal, contact support.",
          "30884": "Your campaign was flagged for spam or phishing. This can't be fixed by resubmitting. To appeal, contact support.",
          "30885": "Your campaign was flagged as high-risk for fraud or deceptive marketing, or your privacy policy shares consent or phone numbers with third parties. This can't be fixed by resubmitting. To appeal, contact support.",
          "30886": "Your campaign description doesn't fully explain the campaign's purpose, or doesn't match your use case. Make it accurate and detailed, saying clearly who sends the messages and why, then resubmit.",
          "30887": "Your opt-out workflow is unclear or missing opt-out keywords or a message. Describe the opt-out process in the message flow, add opt-out keywords, and make the opt-out message confirm the request, say no further messages will be sent, and include your brand name.",
          "30888": "Your campaign needs an age gate — a step on your website or opt-in that confirms visitors are old enough. Add one, then resubmit.",
          "30889": "You selected embedded phone numbers, but your sample messages don't include one. Add an embedded phone number to the samples, or turn off that selection.",
          "30890": "Your HELP reply is missing your brand name, phone number, or email. Add contact details so customers know who to reach after replying HELP.",
          "30891": "The website URL you provided isn't working. Make sure your website is live, or note in the campaign description if it's a pre-launch site.",
          "30892": "Your sample messages use a public link shortener (like bit.ly) or a non-secure URL. Remove public shorteners and use secure links.",
          "30893": "Your sample messages are missing, unclear, or don't match your use case. Use real messages you'll send, mark templated fields with [brackets], include your business name in at least one, and match your use case.",
          "30894": "Your campaign isn't clearly tied to your registered business. Check that your brand information matches the campaign, then resubmit.",
          "30895": "Your campaign looks like direct lending, but that isn't clear in your details. If you offer direct lending, say so in your campaign description; if not, update the description so it doesn't read as lending.",
          "30896": "Your opt-in process isn't clear enough, or consent is shared with third parties. List every way customers opt in (link a hosted image if it's on paper or behind a login), make sure your site has a privacy policy and terms, and don't share opt-in consent with third parties.",
          "30897": "Your campaign includes disallowed content (such as loans, debt collection, gambling, crypto, or lead generation), or shares consent or phone numbers with third parties. This can't be fixed by resubmitting. To appeal, contact support.",
          "30898": "The same EIN is registered for too many brands. Register only the brands you need per EIN, and update your brand registration before resubmitting.",
          "30903": "Your business doesn't qualify as a sole proprietor. Register as a standard business and choose a use case that fits.",
          "30907": "Your website doesn't match your campaign description or brand information. Make sure the website lines up with your registered brand and campaign.",
          "30908": "A compliant privacy policy wasn't found. Make your privacy policy publicly accessible and include a direct link in the message flow.",
          "30909": "We couldn't verify how customers opt in (your call-to-action). Provide complete opt-in details and every method customers use to consent; if it's behind a login, add hosted screenshots.",
          "30910": "Your registration has non-English text. Use English in all fields, and include English translations of your sample messages.",
          "30911": "The same text was reused across fields, or your sample messages are identical. Make each field and each sample message unique.",
          "30912": "Your messages look like personal, one-to-one texting rather than business messaging. Describe the software or platform that sends the messages and how it serves your customers.",
          "30913": "Marketing consent must be collected separately from transactional consent. Add a separate opt-in for promotional messages, or say in your description if you only send transactional messages.",
          "30914": "Your campaign content doesn't match your registered sole-proprietor name. Align your description, samples, and website with that name.",
          "30915": "You registered as a sole proprietor but used a company name (LLC, Inc.). Re-register as a standard business using your EIN.",
          "30916": "You selected lead generation but described lead nurture, or the other way around. Lead generation is outreach to new leads; lead nurture is engaging existing ones. Choose the one that matches.",
          "30917": "You listed multiple opt-in methods but didn't describe them all. Update your opt-in workflow to cover every method.",
          "30918": "Your DBA name doesn't match the legal name on file. Add your DBA name to your brand registration before resubmitting.",
          "30919": "Your website is missing business information or a messaging disclosure. Add your company name, services, contact info, privacy policy, and a mention of your SMS program.",
          "30920": "Your website is just a form with no business context. Add your company name, what your business does, and contact information.",
          "30921": "Reviewers can't reach your website because it needs a login. Create a public page describing your business and messaging program.",
          "30922": "Your website doesn't meet verification requirements (under construction or a non-standard URL). Provide a working, standard URL; if it's pre-launch, note that and add screenshots.",
          "30923": "Messaging consent is bundled into required terms. Make opt-in a separate, optional step, so customers can decline messaging and still use your service.",
          "30924": "Your consent language is missing required disclosures. Near the opt-in checkbox, include the message type, frequency, 'message and data rates may apply', and STOP instructions.",
          "30925": "Your opt-in form is missing a checkbox, or it's pre-checked. Add an SMS consent checkbox that's unchecked by default.",
          "30926": "Your campaign references more than one company or brand. Register a separate campaign for each brand.",
          "30927": "Your opt-in evidence shows a different company than the one registered. Make sure it shows the exact brand name on this campaign.",
          "30928": "Social influencer or public-figure messaging isn't a valid use case. Register as a business and frame the campaign around your business use case.",
          "30929": "Emergency alert notifications aren't allowed on this type of SMS registration. Contact support about alternatives.",
          "30930": "Your brand has reached the 100-campaign limit. Remove unused campaigns to free up space.",
          "30931": "Your opt-in form doesn't let customers decline messaging. Add a skip option or an unchecked checkbox, so one button doesn't grant every permission at once.",
          "30932": "Your privacy policy says opt-in data is shared with third parties for marketing. Update it to state that mobile information won't be shared with third parties for marketing.",
          "30940": "Your campaign involves cannabis, CBD, marijuana, or illegal substances, which aren't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30941": "Your campaign involves prescription drugs or controlled substances, which aren't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30942": "Your campaign involves loan marketing (payday, auto-title, or personal loans), which isn't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30943": "Your campaign involves third-party debt collection, which isn't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30944": "Your campaign involves gambling or betting, which isn't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30945": "Your campaign involves sweepstakes or contests, which aren't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30946": "Your campaign involves stock alerts or investment signals, which aren't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30947": "Your campaign involves cryptocurrency trading or token promotions, which aren't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30948": "Your campaign involves high-risk investments (forex, binary options), which aren't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30949": "Your campaign involves debt reduction or consolidation, which isn't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30950": "Your campaign involves credit repair services, which aren't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30951": "Your campaign involves third-party lead generation or multi-level marketing, which isn't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30952": "Your use case isn't federally compliant and isn't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30953": "Your campaign includes sex or adult content, which isn't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30954": "Your campaign includes hate speech, violence, or offensive content, which isn't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30955": "Your campaign promotes alcohol, which isn't allowed without meeting strict requirements. This can't be fixed by resubmitting. To appeal, contact support.",
          "30956": "Your alcohol-related campaign needs a 21+ age gate — a step confirming visitors are 21 or older. Add one to your website or opt-in, then resubmit.",
          "30957": "Your campaign involves firearms, fireworks, or explosives, which aren't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30958": "Your campaign involves tobacco or vape products, which aren't allowed. This can't be fixed by resubmitting. To appeal, contact support.",
          "30959": "Your campaign was flagged for fraudulent or misleading content. This can't be fixed by resubmitting. To appeal, contact support.",
          "30960": "Your campaign was identified as a known phishing campaign. This can't be fixed by resubmitting. To appeal, contact support.",
          "30961": "Your website or a linked URL has a high-risk domain reputation. This can't be fixed by resubmitting. To appeal, contact support.",
          "30962": "Your campaign uses deceptive marketing (false urgency, bait-and-switch, or fake endorsements). This can't be fixed by resubmitting. To appeal, contact support.",
          "30963": "Your campaign uses public link shorteners (like bit.ly or tinyurl). Replace them with branded links on your own domain, then resubmit.",
          "30964": "Your campaign URLs use HTTP instead of HTTPS. Switch to secure HTTPS links, then resubmit.",
          "30995": "Your account has reached its phone-number limit. Contact support."
        },
        "BADGE_DRAFT": "Draft",
        "BADGE_IN_REVIEW": "In Review",
        "BADGE_APPROVED": "Approved",
        "BADGE_ACTION_REQUIRED": "Action Required"
      }
    },
    "INFO_BANNER": {
      "LEARN_MORE": "Learn more"
    },
    "LEARN_MORE_MODAL": {
      "TITLE": "Required registration for SMS",
      "REGULATORY_COMPLIANCE": {
        "TITLE": "SMS Regulatory Compliance Requirements",
        "INTRO": "SMS messaging regulations vary by country to ensure consumer protection and prevent spam. Your business location requires compliance with local telecommunications regulations before sending SMS messages to customers.",
        "INFORMATION_REQUIRED_TITLE": "What information is required?",
        "INFORMATION_REQUIRED_TEXT": "Regulatory compliance typically requires providing business registration documents, tax identification numbers, and proof of business address. The exact requirements depend on your country's telecommunications authority.",
        "PROCESSING_TIME_TITLE": "How long does the compliance process take?",
        "PROCESSING_TIME_TEXT": "Processing times vary by country and regulatory authority, but is typically 1 day once all required documentation has been submitted and verified.",
        "REQUIRED_DOCUMENTATION_TITLE": "Required documentation",
        "REQUIRED_DOCUMENTATION_TEXT": "You will need to provide official business registration documents, such as:",
        "REQUIRED_DOCUMENTS": {
          "BUSINESS_REGISTRATION": "Business registration certificate",
          "TAX_IDENTIFICATION": "Tax identification documents",
          "PROOF_OF_ADDRESS": "Proof of business address",
          "REPRESENTATIVE_ID": "Company representative identification"
        },
        "DOCUMENTATION_NOTE": "Ensure all documents are current, clearly legible, and match the information provided in your registration form."
      }
    }
  },
  "SMS_BUILDER": {
    "SMS_CONFIGURATION": "SMS Configuration",
    "PREVIEW": "Preview",
    "SMS_EXCEED_CREDIT_LIMIT_INFO": "SMS messages of up to 160 characters consume 1 credit. Messages exceeding 160 characters, up to 220 including URLs and dynamic fields, consume 2 credits but are delivered as a single text message.<br> <br> <b>Note:</b> Using emojis or special characters reduces the character limit and will increase the credit cost.",
    "ACTIONS": {
      "CANCEL": "Cancel",
      "SAVE": "Save"
    },
    "PLACEHOLDERS": {
      "TITLE": "My SMS template",
      "MESSAGE": "Hello!"
    }
  },
  "SMS_REGULATION": {
    "COMMON": {
      "SUBMIT": "Submit information",
      "RESUBMIT": "Resubmit",
      "STATUS": {
        "APPROVED_MESSAGE": "Your registration has been approved. You're ready to send messages.",
        "PENDING_REVIEW_MESSAGE": "We've received your submission. Review may take a few business days.",
        "REJECTION_REASON": "Rejection reason:",
        "REJECTION_SUMMARY": "Your submission was rejected.",
        "REJECTED_NO_REASON_TITLE": "Your submission was rejected.",
        "REJECTED_NO_REASON_DETAIL": "No specific reason was provided.",
        "REJECTED_UPDATE_HINT": "Please update the information below and resubmit.",
        "NUMBER_REQUESTING_MESSAGE": "Your registration has been approved. You can send alphanumeric messages. Requesting phone number.",
        "NUMBER_ACTIVE_MESSAGE": "Your registration has been approved. You're ready to send alphanumeric messages and make phone calls.",
        "NUMBER_FAILED_MESSAGE": "Your registration has been approved. You can send alphanumeric messages. Phone number provisioning failed.",
        "RESOURCE_TYPE": {
          "UTILITY_BILL": "Utility bill",
          "GOVERNMENT_ISSUED_DOCUMENT": "Government-issued ID",
          "INDIVIDUAL": "Individual",
          "BUSINESS": "Business",
          "UNKNOWN": "Submission detail"
        },
        "TWILIO_ERROR": {
          "18001": "The uploaded document does not match the Regulatory Requirements criteria. Please upload a Supporting Document that matches the necessary Regulatory Requirements.",
          "18002": "The document you have uploaded is not legible. Please re-submit a clear copy of the supporting document.",
          "18003": "The submitted Supporting Document is expired or is invalid. Please resubmit a valid supporting document.",
          "18004": "The submitted Supporting Document had redactions or covered information. Re-upload the Supporting Document without any redactions or covered portions.",
          "18005": "There is missing information. Please fill out the required form fields.",
          "18006": "The information does not match the regulatory requirement.",
          "18007": "The Proof of Identity document needs to show the front and back of the ID. Please upload a copy of both sides in a single document.",
          "18008": "The name on the Proof of Identity document does not match what's submitted in the first name / last name fields. Please ensure the document and field information match.",
          "18009": "There is a mismatch between the nationality provided in the form and the Proof of Identity document. Please ensure that the information matches between form fields and Proof of Identity document.",
          "18010": "Business registration number does not match with the local company register or the excerpt from the commercial register that you may have submitted. Please resubmit with the accurate Business Registration number.",
          "18011": "Business name provided does not match with the domestic company register or excerpt from the commercial register that you may have submitted. Please resubmit with the accurate business name.",
          "18012": "The phone number type you selected requires a valid domestic address on the document. Please resubmit a document with a valid address and ensure you've selected the desired phone number type.",
          "18013": "This phone number type requires a valid domestic emergency address on the document. Please resubmit a document with a valid domestic address and ensure you've selected the desired phone number type.",
          "18014": "The address you have provided is not valid. Please resubmit the bundle with the correct address.",
          "18015": "The emergency address you have provided is not valid. Please resubmit the bundle with the correct address.",
          "18016": "The address does not match exactly with the Supporting Document. Please amend the Address fields to match the document's address.",
          "18017": "The Proof of Identity document does not show a visible address. Please upload a Supporting Document with a visible address.",
          "18018": "The address you shared is a PO Box address, which is not acceptable. Please share a full physical address.",
          "18019": "We require Proof of Identity for the Authorized Representative. Please provide a government-issued ID or passport for the Authorized Representative.",
          "18020": "The Authorized Representative is not shown on the Business Registration. Please upload a Supporting Document that shows the Authorized Representative of the business.",
          "18021": "The name on the Proof of Address document does not match what's submitted in the first name / last name fields. Please ensure the document and field information match.",
          "18022": "The address document you shared is outdated. If you are an individual, please share the document issued in the last three months. If you are a business, please share the document issued within the last year.",
          "18023": "The status of your entity is listed as inactive in your local business registry. Please upload a Business Document showing a currently active business registration.",
          "18024": "A document could not be uploaded either because it is corrupted or could not be parsed or processed. Please resubmit with a valid/uncorrupted file.",
          "18025": "Document was rejected since the account is not allowed to purchase this number type. Please contact support for any questions.",
          "18036": "One or more of the required information is missing.",
          "18037": "Missing information in the form",
          "18038": "Information does not match the supporting document",
          "18039": "The phone number type you selected requires a valid domestic address.",
          "18050": "There is an issue with one or more of your Supporting Documents. Please review each rejection reason for the Supporting Document(s).",
          "18051": "There is an issue with the inputs you provided, more details will be sent to the Authorized Representative's email.",
          "18052": "We do not permit underage individuals on our platform. Please resubmit for an individual with acceptable age (over the age of 13 in the US and UK or 16, in the EEA).",
          "18053": "The business name does not match the website SSL certificate, or the website URL, or the association cannot be verified.",
          "18054": "The phone number you provided is not valid. Please review and provide a valid phone number in E164 format.",
          "18055": "The email you provided is not valid. Please resubmit the bundle with a valid email address.",
          "18056": "We require the work email of the Authorized Representative. Please resubmit with a work email of the Authorized Representative.",
          "18057": "The digital validation for the authorized representative has failed. Please resubmit with an identity document for the Authorized Representative.",
          "18058": "Authorized Representative's Tax ID is missing. Please amend the Tax ID Number field in the Business & Legal Representative Information section to the Authorized Representative´s personal tax ID.",
          "18059": "An Authorized Representative's government-issued photo ID document missing or invalid. Please resubmit with a valid supporting document.",
          "18060": "Excerpt from the commercial register is missing, which is a required supporting document. Please re-submit after uploading the excerpt from the commercial register",
          "18061": "We are unable to validate your company registration from the government database, please resubmit with a current and accurate excerpt from the commercial register.",
          "18062": "The status of your entity is listed as inactive in your local business registry. Please amend the business details to include an active business registration.",
          "18063": "This account is not allowed to purchase this number type. Please contact support for any questions.",
          "18064": "The information provided does not meet our business criteria. Please consider resubmitting as an individual.",
          "18099": "The information was rejected since API request marked it as a test. Resubmit with the IsTest parameter to False or omitted if it should be considered for approval.",
          "18601": "The association between business name and website cannot be verified",
          "18602": "The Business ID you provided could not be verified",
          "18603": "The address could not be verified",
          "18604": "Unable to verify Authorized representative #1",
          "18605": "Unable to verify Authorized representative #2. ",
          "18606": "The Email domain doesn't match the website domain",
          "18607": "Customer Profile or Trust Product is not eligible to be copied",
          "18608": "Customer Profile or Trust Product is already copied",
          "18609": "Ineligible Business Registration Authority",
          "18610": "Customer Profile or Trust Product cannot be copied due to a deleted Address"
        },
        "STAGES": {
          "SUBMIT_INFORMATION": "Submit information",
          "INFORMATION_SUBMITTED": "Information submitted",
          "REVIEW": "Review",
          "APPROVED": "Approved",
          "BUSINESS_INFORMATION": "Business information",
          "REJECTED": "Rejected",
          "PHONE_NUMBER_PROVISIONING": "Phone number provisioning"
        }
      },
      "ADDRESS": {
        "STREET_ADDRESS_PRIMARY": "Address",
        "STREET_ADDRESS_SECONDARY": "Additional address line",
        "CITY": "City",
        "STATE": "State/Province",
        "POSTAL_CODE": "Postal code"
      },
      "FILE_UPLOADER": {
        "ACCEPTED_FILE_TYPES": "A PDF, JPG or PNG file. Up to {{ numberOfMegabytes }} MB"
      }
    },
    "SOUTH_AFRICA": {
      "TITLE": "South African SMS Regulatory Compliance Form",
      "SUBTITLE": "This information is required to get a South African SMS number",
      "BUSINESS_IDENTITY": {
        "TITLE": "Business Identity",
        "BUSINESS_NAME": "Business name",
        "BUSINESS_REGISTRATION_NUMBER": "Business registration number",
        "ACCEPTED_DOCUMENTS": {
          "TITLE": "Proof of business identity",
          "HINT": "The type of document uploaded as proof of business identity",
          "BUSINESS_REGISTRATION": "Business registration",
          "CERTIFIED_LETTERHEAD": "Certified copy of business letterhead or similar document"
        }
      },
      "BUSINESS_ADDRESS": {
        "TITLE": "Business Address",
        "ACCEPTED_DOCUMENTS": {
          "TITLE": "Proof of address",
          "HINT": "The type of document uploaded as proof of address",
          "BANK_STATEMENT": "Bank statement",
          "MUNICIPAL_RATES_OR_TAX_INVOICE": "Municipal rates or tax invoice",
          "RECENT_PHONE_BILL": "Recent phone bill",
          "NEW_VEHICLE_LICENSE": "New motor vehicle license"
        }
      },
      "AUTHORIZED_REPRESENTATIVE": {
        "TITLE": "Authorized business representative",
        "FIRST_NAME": "First name",
        "LAST_NAME": "Last name",
        "IDENTITY_NUMBER": "Identity number",
        "IDENTITY_NUMBER_HINT": "The identity number for your government issued ID",
        "NATIONALITY": "Nationality",
        "ACCEPTED_DOCUMENTS": {
          "TITLE": "Proof of identity",
          "HINT": "Upload your government issued ID (must include full name and identity number)",
          "GOVERNMENT_ISSUED_ID": "Government issued ID"
        }
      }
    },
    "AUSTRALIA": {
      "TITLE": "Australian SMS Regulatory Compliance Form",
      "SUBTITLE": "This information is required to get an Australian SMS number",
      "BUSINESS_IDENTITY": {
        "TITLE": "Business Information",
        "BUSINESS_NAME": "Business name",
        "BUSINESS_ID_NUMBER": "Business ID number",
        "BUSINESS_ID_NUMBER_HINT": "Your Australian Business Number (ABN) or Australian Company Number (ACN)",
        "ACCEPTED_DOCUMENTS": {
          "TITLE": "Proof of business identity",
          "HINT": "The type of document uploaded as proof of business identity",
          "UPLOAD_HINT": "Upload a commercial registry document or equivalent",
          "COMMERCIAL_REGISTER": "Commercial register"
        }
      },
      "BUSINESS_ADDRESS": {
        "TITLE": "Business Address",
        "ACCEPTED_DOCUMENTS": {
          "TITLE": "Proof of address",
          "HINT": "The type of document uploaded as proof of address",
          "COMMERCIAL_REGISTER": "Commercial registry showing address",
          "UTILITY_BILL": "Utility bill",
          "TAX_NOTICE": "Tax notice",
          "RENT_RECEIPT": "Rent receipt",
          "TITLE_DEED": "Title deed"
        }
      }
    },
    "ITALY": {
      "TITLE": "Italian Phone Regulatory Compliance Form",
      "SUBTITLE": "This information is required to register your Italian phone number",
      "BUSINESS_TYPE": {
        "LABEL": "Business type",
        "BUSINESS": "Corporation",
        "SOLE_PROPRIETOR": "Sole proprietorship"
      },
      "BUSINESS": {
        "TITLE": "Business Information",
        "BUSINESS_NAME": "Business name",
        "BUSINESS_NAME_MAX_LENGTH": "Business name must be {{ max }} characters or fewer.",
        "VAT": "VAT number",
        "SOLE_PROPRIETOR": {
          "BUSINESS_NAME": "Owner name or trade name"
        }
      },
      "BUSINESS_ADDRESS": {
        "TITLE": "Business Address",
        "ACCEPTED_DOCUMENTS": {
          "TITLE": "Proof of address",
          "HINT": "The type of document uploaded as proof of address",
          "BUSINESS_REGISTRY": "Business registry showing the address",
          "UTILITY_BILL": "Utility bill",
          "TAX_NOTICE": "Tax notice",
          "RENT_RECEIPT": "Rent receipt",
          "TITLE_DEED": "Title deed"
        }
      },
      "AUTHORIZED_REPRESENTATIVE": {
        "TITLE": "Authorized business representative",
        "FIRST_NAME": "First name",
        "LAST_NAME": "Last name",
        "BIRTH_DATE": "Birth date",
        "BIRTH_PLACE": "Birth place",
        "NATIONALITY": "Nationality",
        "TAX_ID_NUMBER": "Codice fiscale",
        "DOCUMENT_NUMBER": "Government-issued ID number",
        "DOCUMENT_NUMBER_HINT": "Document number from your government-issued ID or passport",
        "ISSUING_AUTHORITY": "Issuing authority",
        "ISSUE_DATE": "Issue date",
        "ACCEPTED_DOCUMENTS": {
          "TITLE": "Proof of identity",
          "HINT": "Upload a color copy of your identification document showing both sides (must include ID number, issuing authority, and issue date)",
          "GOVERNMENT_ISSUED_ID": "Government-issued ID",
          "PASSPORT": "Passport"
        },
        "SOLE_PROPRIETOR": {
          "TITLE": "Owner Information"
        }
      }
    }
  }
}
